import { Presenter } from '../../../common/ddd/presenter.base';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { SelfAppAverageSummaryEntity } from '../../../core/domain/entities/scores/self-app-average-summary.entity';
import { SelfAppCalendarEventsAverageSummaryEntity } from '../../../core/domain/entities/scores/self-app-calendar-events-average-summary.entity';
import { SelfAppAverageSummaryEntityMapper } from '../../../infrastructure/mappers/scores/self-app-average-summary.mapper';
import { SelfAppCalendarEventsAverageSummaryEntityMapper } from '../../../infrastructure/mappers/scores/self-app-calendar-events-average-summary.mapper';
import { GetSelfAppAveragesSummaryResponseDto } from '../../dtos/scores/get-self-app-averages-summary.response.dto';
export interface GetSelfAppAveragesSummaryPresenterProps {
  apps: SelfAppAverageSummaryEntity;
  calendarEvents: SelfAppCalendarEventsAverageSummaryEntity;
}

export class GetSelfAppAveragesSummaryPresenter
  implements
    Presenter<
      GetSelfAppAveragesSummaryPresenterProps,
      GetSelfAppAveragesSummaryResponseDto
    >
{
  constructor(
    protected readonly logManager: LogManager,
    protected readonly selfAppAverageSummaryEntityMapper: SelfAppAverageSummaryEntityMapper,
    protected readonly selfAppCalendarEventsAverageSummaryEntityMapper: SelfAppCalendarEventsAverageSummaryEntityMapper
  ) {}

  toResponse(
    entities: GetSelfAppAveragesSummaryPresenterProps
  ): GetSelfAppAveragesSummaryResponseDto {
    try {
      return {
        ...this.selfAppAverageSummaryEntityMapper.toResponse(entities.apps),
        ...this.selfAppCalendarEventsAverageSummaryEntityMapper.toResponse(
          entities.calendarEvents
        ),
      } as GetSelfAppAveragesSummaryResponseDto;
    } catch (error) {
      throw new Error(
        `GetSelfAppAveragesSummaryPresenter.toResponse encountered an error ${error}`
      );
    }
  }
}
